import Button from "components/atoms/button/Button";
import Icon from "components/atoms/icon/Icon";
import { useTranslation } from "react-i18next";
import { IconType } from "../iconTypes";

export const pendingHeaders = (
    { setModalData, isOwn = false }: {
        setModalData?: (data: { modalType: string; data: any, isOwn: boolean }) => void,
        isOwn?: boolean
    }) => {


    return [
        {
            id: 1,
            Header: "Deadline",
            accessor: (row: any) => row?.deadline ? new Date(row?.deadline) : 'deadline',
            Cell: ({ row: { original } }: any) => {
                return (
                    <p
                        className="text-[14px] font-inter-medium text-[#282D46] cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "appLead", data: original, isOwn: isOwn })}
                    >
                        {original?.deadline ? new Date(original?.deadline).toLocaleDateString('de') : "-"}
                    </p>
                );
            },
            isChecked: true,
        },
        {
            id: 2,
            Header: "Pending Title",
            accessor: "title",
            Cell: ({ row: { original } }: any) => {
                return (
                    <div
                        className="flex gap-1 items-center cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "appLead", data: original, isOwn: isOwn })}
                    >

                        <p className="text-[14px] font-inter-medium text-[#282D46]">
                            {original?.pending_name}
                        </p>
                    </div>
                );
            },
            isChecked: true,
        },
        {
            id: 3,

            Header: "Worker",
            accessor: "from_user",
            Cell: ({ row: { original } }: any) => {
                return (
                    <div
                        className="flex gap-1 items-center cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "appLead", data: original, isOwn: isOwn })}
                    >
                        <h1 className="text-[14px] font-inter-medium text-[#282D46]">
                            {isOwn
                                ? (original?.user.name + ' ' + original?.user.last_name)
                                : original?.to_user_id
                            }
                        </h1>
                    </div>
                );
            },
            isChecked: true,
        },
        {
            id: 4,

            Header: "Status",
            accessor: "status",
            Cell: ({ row: { original } }: any) => {
                const status = original?.completed === 1 ? 'Done' : 'Open';
                return (
                    <div className="cursor-pointer" onClick={() => setModalData && setModalData({ modalType: "appLead", data: original, isOwn: isOwn })}>
                        <PendingStatus status={status} />
                    </div>
                );
            },
            isChecked: true,
        },
        {
            id: 5,
            Header: "Completed At",
            accessor: (row: any) => row?.completed_at ? new Date(row?.completed_at) : 'completed_at',
            Cell: ({ row: { original } }: any) => {
                return (
                    <p
                        className="text-[14px] font-inter-medium text-[#282D46] cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "appLead", data: original, isOwn: isOwn })}
                    >
                        {original?.completed_at ? new Date(original?.completed_at).toLocaleDateString('de') : '-'}
                    </p>
                );
            },
            isChecked: true,
        },
        {
            id: 6,
            Header: "",
            accessor: "actions",
            Cell: ({ row: { original } }: any) => {
                return (
                    <div
                        className="flex items-center gap-[3px] ml-auto justify-end cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "appLead", data: original, isOwn: isOwn })}
                    >
                        <Button
                            type="button"
                            onClick={() => setModalData && setModalData({ modalType: "appLead", data: original, isOwn: isOwn })}
                        >
                            <Icon iconType={IconType.SHOW_PASSWORD_ICON} />
                        </Button>
                        {/* <Icon iconType={IconType.DELETE_ICON} color="#7D8592" /> */}
                    </div>
                );
            },
            isChecked: true,
        }
    ];

}

const PendingStatus = ({ status }: { status: string }) => {

    const { t } = useTranslation()

    return (
        <p

            className={`min-w-[50px] cursor-pointer w-[max-content] h-[24px] p-3 text-[12px] font-inter-medium flex items-center justify-center rounded-[4px] capitalize 
                            ${status === "Done"
                    ? "bg-[#2DE28B] bg-opacity-[10%] text-[#2DE28B]"
                    : status === "Open"
                        ? "bg-[#F88532] bg-opacity-[10%] text-[#F88532]"
                        : ""
                }`}
        >
            {t(status)}
        </p>
    )
}
